
import React from 'react'
import { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const InputEvent = () => {


  const userType = sessionStorage.getItem("usertype");
  const userId = sessionStorage.getItem("userId");

  const [name,setName] = useState()
  const [eventdate,setEventdate] = useState()
  const [venue,setVenue] = useState()

    const [designation, setDesignation] = useState("")

  const navigate = useNavigate()

const eventPost = () => {
  const dist = sessionStorage.getItem("dist"); // or however you're managing dist

  axios.post('https://lionsdirectoryapi.emedha.in/notification/api/api/events', {
    name,
    eventdate,
    venue,
    dist
  }).then((res) => {
    alert(res.data.message);
    setTimeout(() => navigate('/view-events'), 200);
  }).catch((err) => {
    alert(err.response?.data?.message || "Failed to create event");
  });
};

  return (
    <div className='conatner add-project-container'>
      <label>Event Name</label>
        <input type='text' className='form-control' placeholder='Event Name' onChange={(e)=> setName(e.target.value)}/>
        <br></br>
        <label>Event Date</label>
        <input type='date' className='form-control' placeholder='Event Date' onChange={(e)=> setEventdate(e.target.value)}/>
        <br></br>
        <label>Venue</label>
        <textarea type='text' rows={6} className='form-control' placeholder='Venue' onChange={(e)=>setVenue(e.target.value)}/>
        <br></br>
        <br />
       
        <button className='btn btn-danger mb-2' onClick={eventPost}>Submit</button>
        <br></br>
    </div>
  )
}

export default InputEvent